import styled from 'styled-components';

import {
  HERO_FONT_DISPLAY,
  LandingHero,
} from 'constants/landing-hero';

// Below this, 9 swatches (None + 8 colors) at full size no longer fit one
// row inside the panel — checked against a 320px-wide viewport as the floor.
const NARROW = '@media (max-width: 480px)';

export const Panel = styled.div`
  width: 100%;
  max-width: 42rem;
  background: ${LandingHero.neutral.cardBg};
  border: 0.1rem solid ${LandingHero.neutral.cardBorder};
  border-radius: 2rem;
  padding: 2.8rem 2.6rem;
  display: flex;
  flex-direction: column;
  gap: 2rem;
  text-align: left;
  backdrop-filter: blur(1.4rem);
  -webkit-backdrop-filter: blur(1.4rem);
  box-shadow: inset 0 0.1rem 0 ${LandingHero.cardInsetHighlight};

  ${NARROW} {
    padding: 2rem 1.6rem;
  }
`;

export const IntroGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
`;

export const Kicker = styled.div`
  font-size: 1.1rem;
  font-weight: 800;
  letter-spacing: 0.16rem;
  text-transform: uppercase;
  color: ${LandingHero.creator.kicker};
`;

export const Title = styled.div`
  font-family: ${HERO_FONT_DISPLAY};
  font-size: 1.8rem;
  font-weight: 800;
  color: ${LandingHero.textPrimary};
`;

export const Caption = styled.div`
  font-size: 1.3rem;
  line-height: 1.5;
  color: ${LandingHero.textMuted};
`;

export const FieldGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const SectionLabel = styled.div`
  font-size: 1.2rem;
  font-weight: 700;
  color: ${LandingHero.textMutedSoft};
`;

export const SegmentRow = styled.div`
  display: flex;
  gap: 0.4rem;
  padding: 0.4rem;
  border-radius: 1.2rem;
  background: ${LandingHero.navPillBg};
  border: 0.1rem solid ${LandingHero.navPillBorder};
`;

export const SegmentItem = styled.button<{ $active: boolean }>`
  flex: 1;
  background: ${({ $active }) =>
    $active ? LandingHero.skyCtaGradient : 'transparent'};
  color: ${({ $active }) =>
    $active ? LandingHero.skyCtaText : LandingHero.navLink};
  font-size: 1.3rem;
  font-weight: 700;
  padding: 1rem 0;
  border-radius: 0.9rem;
  border: none;
  cursor: pointer;
  font-family: inherit;
  transition: color 0.25s ease;
`;

export const SwatchRow = styled.div`
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  gap: 0.9rem;
  overflow-x: auto;

  ${NARROW} {
    gap: 0.5rem;
  }
`;

export const Swatch = styled.button<{ $color: string; $selected: boolean }>`
  width: 3.2rem;
  height: 3.2rem;
  border-radius: 999rem;
  background: ${({ $color }) => $color};
  border: 0.2rem solid
    ${({ $selected }) => ($selected ? LandingHero.textPrimary : 'transparent')};
  box-shadow: 0 0 0 0.1rem ${LandingHero.chipBorder};
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 1.4rem;
  color: ${LandingHero.logoText};

  ${NARROW} {
    width: 2.6rem;
    height: 2.6rem;
    font-size: 1.2rem;
  }
`;

export const SwatchEmpty = styled.button<{ $selected: boolean }>`
  width: 3.2rem;
  height: 3.2rem;
  border-radius: 999rem;
  background: ${LandingHero.chipBg};
  border: 0.2rem solid
    ${({ $selected }) => ($selected ? LandingHero.textPrimary : 'transparent')};
  box-shadow: 0 0 0 0.1rem ${LandingHero.chipBorder};
  cursor: pointer;
  flex-shrink: 0;
  font-size: 1rem;
  font-weight: 700;
  color: ${LandingHero.textFaint};
  font-family: inherit;

  ${NARROW} {
    width: 2.6rem;
    height: 2.6rem;
    font-size: 0.9rem;
  }
`;
